import { render, staticRenderFns } from "./RestaurantAreas.vue?vue&type=template&id=4f68bb05"
import script from "./RestaurantAreas.vue?vue&type=script&lang=js"
export * from "./RestaurantAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports